import { formatDecimalSeparator } from "src/v2/utils/formatter/format-number"

const asArray = (value) => Array.isArray(value) ? value : []

export const normalizeMarketToMarketPayload = (payload = {}) => ({
    curvas: asArray(payload?.curvas),
    scatters: asArray(payload?.scatters),
    boxPlot: asArray(payload?.box_plot),
})

export const mapScatterChartData = (data = []) => {
    if (!Array.isArray(data)) return []

    return data.map((item) => {
        const { CETIP, DurationAno, SpreadCredito, IndiceLiquidez, Indicador, Rating } = item
        return {
            label: CETIP,
            type: "scatter",
            data: [{ x: DurationAno, y: SpreadCredito }],
            tooltip:
                `CETIP: ${CETIP ?? "N/D"} <br>` +
                `Duration: ${formatDecimalSeparator(DurationAno, "N/D")}<br>` +
                `Indicador: ${Indicador ?? "N/D"} <br>` +
                `Rating: ${Rating ?? "N/D"} <br>` +
                `Spread Crédito: ${formatDecimalSeparator(SpreadCredito, "N/D")}<br>` +
                `Indice Liquidez: ${formatDecimalSeparator(IndiceLiquidez, "N/D")} <br>`,
        }
    })
}

export const mapBoxPlotChartData = (data = []) => {
    if (!Array.isArray(data)) return []

    return data.map((item) => {
        const { CETIP, Min, Max, Q1, Q3, Median, DurationAno } = item

        return {
            label: CETIP,
            type: "boxplot",
            x: DurationAno,
            data: { Min, Max, Q1, Q3, Median },
            tooltip:
                `CETIP: ${CETIP ?? ""}<br>` +
                `Máximo: ${formatDecimalSeparator(Max, "")} <br>` +
                `Q3: ${formatDecimalSeparator(Q3, "")}<br>` +
                `Mediana: ${formatDecimalSeparator(Median, "")}<br>` +
                `Q1: ${formatDecimalSeparator(Q1, "")}<br>` +
                `Mínimo: ${formatDecimalSeparator(Min, "")}<br>`,
        }
    })
}
